import axios from "axios";
import store from "@/store";
// api 통신시 사용할 axios 전역 변수 설정
// export default {
//   install: (app, options) => {
//     app.config.globalProperties.$axios = axios.create({
//       baseUrl: options.baseUrl,
//       headers: {
//         Authorization: options.token ? `Bearer ${options.token}` : "", // jwt header
//       },
//     });
//   },
// };

const authReq = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    Accept: "application/json",
  },
});
authReq.interceptors.request.use(
  // 전송시 header에 토큰을 담아서 전송
  (config) => {
    const token = localStorage.getItem("user");
    if (token && token != "null") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

authReq.interceptors.response.use(
  // 요청시 전송한 토큰이 만료된 경우, refreshToken과 함께 accessToken 을 전송하여 갱신함.
  (response) => {
    return response;
  },
  async (error) => {
    const {
      config,
      response: { status },
    } = error;
    if (status == 401) {
      console.log(error);
      const originRequest = config;
      await store.dispatch(`userStore/AC_REFRESH_TOKEN`);

      const newAccessToken = localStorage.getItem("user");
      axios.defaults.headers.Authorization = `Bearer ${newAccessToken}`;
      originRequest.headers.Authorization = `Bearer ${newAccessToken}`;

      return axios(originRequest);
    }
    return Promise.reject(error);
  }
);

export const authFetch = authReq;

export const nonAuthFetch = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    Accept: "application/json",
  },
});
